import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';
import FileLogDetail from "./DataLoaderFileLogDetail";
import dataLoaderServices from "./DataLoaderServices";
import Pagination from 'components/Common/newPagination';

export default function DataLoaderFileLog(param: any) {

    let [searchFor, setsearchFor] = useState("");
    let [fileLog, setfileLog] = useState<any[]>([]);
    let [openLoadFile, setopenLoadFile] = useState(0);
    let [fileLogList, setfileLogList] = useState<any[]>([]);
    let [fileLogTotalRow, setfileLogTotalRow] = useState(0);
    let [LoadFileStatus, setLoadFileStatus] = useState(false);

    console.log(param)
    const returnValue = (e: any) => {
        param.onChangeLogFile(e)
    }

    useEffect(() => {
        searchFor = ""
        setsearchFor(searchFor)
        ApiCall();
    }, [param.open]);

    var payload = {
        pageNumber: 1,
        pageSize: 10,
        filename: "None"
    }

    const ApiCall = () => {

        if (searchFor.length > 0) {
            payload.filename = searchFor;
        }
        dataLoaderServices.loadIFileLog(param.type, payload.filename, payload.pageNumber, payload.pageSize, 'none').then((res: any) => {
            setfileLogTotalRow(res[0] ? res[0].totalRows : 0)
            setfileLogList(res)
        })
    }

    const handleNameOnChange = (n: any) => {
        payload.pageNumber = n.pageNumber;
        payload.pageSize = n.pageSize;
        ApiCall()
    }

    const fileLogProgress = (e: any) => {
        setfileLog(e)
        setLoadFileStatus(true)
        console.log(e)
    }

    const onChangeLoadFile = (e: any) => {
        console.log(e)
        setLoadFileStatus(false)
    }

    const fileNameDate = (filename: any) => {
        console.log(filename)

        const zipPosition = filename.indexOf(".zip)")
        console.log(zipPosition)

        const secondLastUnderscore = nthLastIndexOf(filename, "_", 2);
        console.log(secondLastUnderscore)

        const firstLastUnderscore = nthLastIndexOf(filename, "_", 1);
        console.log(firstLastUnderscore)

        const result1 = filename.slice(secondLastUnderscore + 1, firstLastUnderscore);
        console.log(result1)

        return result1
    }

    function nthLastIndexOf(str: string, char: string, n: number): number {
        let lastIndex = str.length;
        for (let i = 0; i < n; i++) {
            lastIndex = str.lastIndexOf(char, lastIndex - 1);
            if (lastIndex === -1) break;
        }
        return lastIndex;
    }

    const downloadFile = (e: any) => {
        console.log(e)

        var url = 'Api/importLog/downloadLogFile/' + e?.originalFileName;
        window.open(url);
    }


    return (
        <div style={{ width: "40%", height: "120%" }}>

            <Modal open={param.open} onClose={() => returnValue(0)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-9 paddingCenterBox pull-right bgTransparent' }} >

                <div className="ws-12 box">
                    <div className="box-header-main ws-12">
                        <h2 className="ws-11"><i className="fa fa-question-circle"></i>View Upload File Log</h2>

                        <div className="ws-1 toolbox pt prxl">
                            <button className="icon-btn delete pull-right" onClick={ApiCall}><i className="icon-refresh1"></i> Reset</button>
                        </div>
                    </div>

                    <div className="box-content">
                        <div className="form-horizontal  form-condensed clearfix ws-12">
                            <div className="row-fluid">
                                <div className="form-format ws-12">
                                    <div className="ws-4">
                                        <label className="control-label">Filename</label>
                                        <div className="label-entries ws-12">
                                            <input type="text" className="form-control pLarge ws-12" placeholder="Enter Filename" value={searchFor} onChange={(e => setsearchFor(e.target.value))} id="filename" />
                                        </div>
                                    </div>

                                    <div className="ws-1 mt ptl">
                                        <button className="icon-btn edit mtl width100 height35" onClick={ApiCall}><i className="fa fa-search"></i>Search </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row-fluid sortable" ng-show="filelogCount !== null">
                        <div className="box span12">
                            {<div className="box-header well">
                                <h2> <i className="fa fa-table"></i> <span>{fileLogTotalRow} record(s) found</span>  </h2>
                            </div>}
                            <div className="box-content">
                                {(fileLogTotalRow == 0) && <div className="alert alert-info"> No records to display</div>}
                                {(fileLogTotalRow > 0) && <div className="table-responsive">
                                    <table className="newTable">
                                        <thead>
                                            <tr>
                                                <th >File</th>
                                                <th >Status</th>
                                                <th ng-if="logType !== 'YT' &amp;&amp; logType !== 'YR' &amp;&amp; logType !== 'GP' &amp;&amp; logType !== 'AZ'" >Template</th>
                                                <th >Date</th>
                                                <th >Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                fileLogList?.map((values: any, index: number) => {
                                                    return (
                                                        <tr className={Number(values.status) === 0 ? "info" : "danger"}>
                                                            <td><a onClick={() => downloadFile(values)} >{values.fileName}</a></td>
                                                            <td >{values.description}</td>
                                                            <td >{values.tempIds}</td>
                                                            <td>{fileNameDate(values?.fileName ?? "")}</td>
                                                            <td>
                                                                <button className="icon-btn edit" onClick={() => { fileLogProgress(values); setopenLoadFile(1) }}><i className="icon-info"></i></button>

                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>

                                    <div className="ws-12 ptl">
                                        {
                                            (() => {
                                                if (fileLogTotalRow && fileLogTotalRow > 10) {
                                                    return <Pagination onPageChange={handleNameOnChange} totalRow={fileLogTotalRow} />
                                                }

                                            })()

                                        }
                                    </div>

                                </div>}

                            </div>


                            {
                                (() => {

                                    if (openLoadFile === 1) {
                                        return (<FileLogDetail onChangeLoadFile={onChangeLoadFile} open={LoadFileStatus} type={fileLog} />)
                                    }

                                })()
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}